import {Component, OnInit, ViewChild} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';


import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {QARService, ReportParticipationEntity, ReportRowEntity} from '../services/qar.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppUser, AppUserData} from '../framework/AppUser';
import {last} from 'rxjs/operators';


@Component({
  selector: 'app-page-report',
  templateUrl: './report.html',
  providers: [QARService]
})
export class ReportPageComponent implements OnInit {

	@ViewChild('modal', {static: false}) modal;

  constructor(public api: QARService, public route: ActivatedRoute, public user: AppUser) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.participation_init();
    });
  }

  public confirm(text, title, cb) {
    this.participation.modalConfirm.display = true;
    this.participation.modalConfirm.text = text;
    this.participation.modalConfirm.title = title;
    this.participation.modalConfirm.cb = (yesorno) => {
      this.participation.modalConfirm.display = false;
      cb(yesorno);
    };
  }

  public alert(text, title = 'Alert') {
    this.participation.modalAlert.display = true;
    this.participation.modalAlert.title = title;
    this.participation.modalAlert.text = text;
    this.participation.modalAlert.cb = (yesorno) => {
      this.participation.modalAlert.display = false;
    };
  }


  public row_onReasonChange(reasonStatus, row, $event = null) {
    let original = $event ? row.reason : null;
    if (reasonStatus === 'null') { 
		reasonStatus = null;
	}
    if (original === 'null') {
		 original = null;
	}
		console.log('onReasonChange', reasonStatus, row.reason, original, $event);

    if (reasonStatus === 'user_left_organisation') {
      this.confirm('A request will be raised to remove all access for this user.\nAre you sure you want to proceed?', 'Warning', (yesorno) => {
        if (yesorno) { 
			this.row_propagate(row, 'reason', reasonStatus);
		} else { 
			console.log('revert');
			row.reason = original; 
			$event.target.value = original; 
			console.log('revert', row.reason);
		}
      }
	);
    } else if (reasonStatus === 'user_has_moved_team') {

      this.confirm('A request will be raised to move this user to the correct team.\nAre you sure you want to proceed?', 'Warning', (yesorno) => {
        if (yesorno) {
			 this.row_propagate(row, 'reason', reasonStatus); 
		} else {
			row.reason = original; 
			$event.target.value = original;
			console.log('revert', row.reason);
		}
      });
    } else {
      this.row_propagate(row, 'reason', reasonStatus);
    }

    if (row.is !== 'role') {
			console.log('REVERT', row);
			$event.target.value = null;
		}
  }

  public row_onDecisionChange(acceptStatus, row) {
		console.log('onDecisionChange', acceptStatus, row.is);
    this.row_propagate(row, 'action', acceptStatus);
  }

  public row_propagate(row, key, value) {
		console.log('row_propagate', key, value);
    if (this.participation.errors[row.index]) {
      this.participation.errors[row.index].count = 0;
    }
    row[key] = value;

    if (this.participation.isSuperApprover && !this.participation.reportAllowedAsApproverWhileBeingSuperApprover) {

		// if action is different
		// OR action is the same but reason is different

		if (row.action !== row.originalAction || (row.action === false && row.reason !== row.originalReason)) {
			row.isOverride = true;
					console.log('+OVERRIDE 1', row);
		} else {
			row.isOverride = false;
		}
		console.log('isSuperApprover : ?', row, row.reason, row.originalReason, row.reason !== row.originalReason);
    }

	// key:reason value:user_left_organisation
    let rowIs = row.is;
    if (key === 'reason' && (value === 'user_left_organisation' || value === 'user_has_moved_team' || value === 'user_unknown')) {
      rowIs = 'user';
    }
    const isRejection = key !== 'action' && value;
		console.log({isRejection, rowIs, key, value});

		if (key === 'action' && value === true) {
			row['reason'] = null;
		}


    switch (rowIs) {
      case 'user':
        for (const r of this.participation.rowsByUserId[row.userId]) {
          	this.participation.rows[r.index][key] = value;
			if (isRejection) {
				this.participation.rows[r.index]['action'] = false;
			} else {
				this.participation.rows[r.index]['reason'] = null;
			}

			// override
         	if (this.participation.isSuperApprover && !this.participation.reportAllowedAsApproverWhileBeingSuperApprover
				&& (
					this.participation.rows[r.index].action !== this.participation.rows[r.index].originalAction
					|| (this.participation.rows[r.index].action === false && this.participation.rows[r.index].reason !== this.participation.rows[r.index].originalReason)
				)
			) {
				console.log('+OVERRIDE 2', r);
            	this.participation.rows[r.index].isOverride = true;
          } else {
            this.participation.rows[r.index].isOverride = false;
          }

					if (this.participation.errors[r.index]) {
						this.participation.errors[r.index].count = 0;
					}
          this.row_saveChanges(r);
        }
        break;
      case 'system':
        for (const r of this.participation.rowsByUserAndSystemId[row.userId][row.systemId]) {
			this.participation.rows[r.index][key] = value;

			if (isRejection) {
				this.participation.rows[r.index]['action'] = false;
			} else {
				this.participation.rows[r.index]['reason'] = null;
			}

			// override
          	if (this.participation.isSuperApprover && !this.participation.reportAllowedAsApproverWhileBeingSuperApprover
				&& (
					this.participation.rows[r.index].action !== this.participation.rows[r.index].originalAction
					|| (this.participation.rows[r.index].action === false && this.participation.rows[r.index].reason !== this.participation.rows[r.index].originalReason)
				)
			) {
				console.log('+OVERRIDE 3', r);
            	this.participation.rows[r.index].isOverride = true;
			} else {
				this.participation.rows[r.index].isOverride = false;
			}

			if (this.participation.errors[r.index]) {
				this.participation.errors[r.index].count = 0;
			}
          this.row_saveChanges(r);
        }
        break;
    }


    this.row_saveChanges(row);
  }

	public row = {
		queue: [],
		doing: false,
		timeout: null
	};

  public row_saveChanges(row) {
    if (row.is === 'role') {
      row.status = 'saving';
      this.row.queue.push(row);
      this.row_queueStart();


			// pairing?
			console.log({row});
      if (row.pairingId) {
        for (const otherRowIndex of this.participation.rolePairing[row.pairingId]) {
          	const otherRow = this.participation.rows[otherRowIndex];
			console.log({otherRowIndex, otherRow});
			if (otherRow.id !== row.id) { // do not propagate to our current row, only to other ones
				otherRow.status = 'saving';
				otherRow.action = row.action;
				otherRow.reason = row.reason;
				otherRow.overrideAction = row.overrideAction;
				otherRow.overrideReason = row.overrideReason;
				otherRow.isOverride = row.isOverride;
				this.row.queue.push(otherRow);
          }
        }
        this.row_queueStart();
      }
    }
  }

	// called every single time there is a change, we do the changes one by one, FIFO
	public row_queueStart() {
		this.row_queue_tick();
	}

  public row_queue_tick() {
		// console.log('row_queue_tick', this.row.doing);
		if (this.row.doing) {
			// console.log('row_queue_tick', 'WAIT');
			return;
		}
		// console.log('row_queue_tick', 'WORK');
    this.row.doing = true;
    const lastItem = this.row.queue.pop();
    if (lastItem) {

			const toSave = {
				id: lastItem.id
			};
      if (this.participation.isSuperApprover && !this.participation.reportAllowedAsApproverWhileBeingSuperApprover) {
        toSave['overrideAction'] = lastItem.action;
        toSave['overrideReason'] = lastItem.reason;
        toSave['isOverride'] = true;
      } else {
        toSave['action'] = lastItem.action;
        toSave['reason'] = lastItem.reason;
      }

      this.api.reports_saveRow(this.participation.id, toSave).then(r => {
        this.participation.rows[lastItem.index].status = 'saved';
        this.row.doing = false;
        this.row_queue_tick();
      }, e => {
        this.participation.rows[lastItem.index].status = 'error';
        this.row.queue.push(lastItem);
        this.row.doing = false;
		console.log('row_queue_tick', 'ERR');
		setTimeout(() => {
			this.row_queue_tick();
		}, 5000);
      }).catch(ce => {
        this.participation.rows[lastItem.index].status = 'error';
        this.row.queue.push(lastItem);
        this.row.doing = false;
		console.log('row_queue_tick', 'ERR');
		setTimeout(() => {
			this.row_queue_tick();
		}, 5000);
      });
    } else {
      this.row.doing = false;
    }
  }

  public row_overrideDescription(r) {
    const action = r.originalAction ? 'accepted' : 'rejected';
    const reason = this.row_reasonDescription(r.originalReason);
    return 'Was ' + action + (action === 'rejected' && reason ? ' with reason "' + reason + '"' : '');
  }

  public row_overrideDescriptionInModal(r) {
    const action = r.StatusId;
    const reason = this.row_reasonDescription(r.RejectionReason);

		let ret = 'Was ' + action + (action === 'rejected' && reason ? ' with reason "' + reason + '"' : '');
		// console.log('row_overrideDescriptionInModal', r, action, reason, ret);
		return ret;
  }

  public row_reasonDescription(reasonId) {
    for (const rr of this.participation.rejectionResons) {
			if (rr.key === reasonId) {
				return rr.value;
			}
    }
    return '';
  }


	public override = {
		modal: {
			isHidden: true
		},
		notes: ''
	};

  public override_submit() {
		console.log('override_submit', this.override.notes);

		// do we have overrides?
    let hasOverride = false;
    for (const r of this.participation.rows) {
			if (r.is === 'role' && r.isOverride) {
				hasOverride = true;
				console.log('IS OVERRIDE', r);
			}
    }

    const countErrors = this.participation_checkForErrors();
    if (countErrors > 0) {
      this.alert('There ' + (countErrors > 1 ? 'are' : 'is') + ' ' + countErrors + ' line' + (countErrors > 1 ? 's' : '') + ' where you need to Accept, or Reject and give a reason.<br>All roles must be Accepted or Rejected before the report can be completed.', 'Warning');
    } else if (hasOverride && (!this.participation.entity.Notes || this.participation.entity.Notes.length < 3)) {
      this.alert('Please enter notes supporting your override decisions', 'Warning');
    } else {
      const text = 'Countersigning this Quarterly Access Review will prevent any further changes to this report.\nAre you sure you want to Countersign?';
      this.override.modal.isHidden = true;
      this.confirm(text, 'Warning', (yesorno) => {
        if (yesorno) {
          this.participation.saving = true;
          this.api.reports_markAsCountersigned(this.participation.id, this.participation.entity.Notes).then(r => {
            this.participation.saving = false;
            this.participation.id = null;
            window.location.reload();
          }, e => {
            this.participation.saving = false;
            this.alert('Sorry, something went wrong when saving, please try again');
          });
        }
      });
    }
  }

  public participation = {
		id: null,
		rolePairing: {},
		rolePairingDisplay: {},
		title: '',
		modalConfirm: {
			display: false,
			title: '',
			text: '',
			cb: (yesorno) => {
			}
		},
		modalAlert: {
			display: false,
			title: '',
			text: '', cb: (yesorno) => {
			}
		},
    reportWasJustSavedByApprover: false,
		errors: {},
		saving: false,
		loading: false,
		readonly: false,
    reportAllowedAsApproverWhileBeingSuperApprover: false,
		isSuperApprover: false,
		isApprover: false,
    entity: new ReportParticipationEntity(),
		rows: [],
		rowsByUserId: {},
		rowsByUserAndSystemId: {},
    rejectionResons: ReportRowEntity.reasonsKeyValues
  };

  public participation_init() {
    this.participation.id = this.route.snapshot.params.id;
		if (this.participation.id) {
			this.participation_load();
		}
    if (window.location.href.indexOf('completed-by-approver') != -1) {
      this.participation.reportWasJustSavedByApprover = true;
    }
  }

  public participation_counterSign() {
    const countErrors = this.participation_checkForErrors();
    if (countErrors > 0) {
      this.alert('There ' + (countErrors > 1 ? 'are' : 'is') + ' ' + countErrors + ' line' + (countErrors > 1 ? 's' : '') + ' where you need to Accept, or Reject and give a reason.', 'Warning');
    } else {
      this.override.modal.isHidden = false;
    }
  }

  public participation_complete() {
    if (this.participation.isSuperApprover && !this.participation.reportAllowedAsApproverWhileBeingSuperApprover) {
      this.alert('Sorry', 'You cannot complete a report as super approver');
    } else {
      const countErrors = this.participation_checkForErrors();
      if (countErrors > 0) {
        this.alert('There ' + (countErrors > 1 ? 'are' : 'is') + ' ' + countErrors + ' line' + (countErrors > 1 ? 's' : '') + ' where you need to Accept, or Reject and give a reason.<br>All roles must be Accepted or Rejected before the report can be completed.', 'Warning');
      } else {
        const message = 'Completion of this Quarterly Access Review will prevent any further changes to this report.<br>Are you sure you want to Complete your review?';
        this.confirm(message, 'Warning', (yes) => {
          if (yes) {
            this.participation.saving = true;
            this.api.reports_markAsComplete(this.participation.id).then(r => {
              this.participation.saving = false;
              this.participation.id = null;
              window.location.replace(window.location.href + '?completed-by-approver');
            }, e => {
              this.participation.saving = false;
              this.alert('Sorry, something went wrong when saving, please try again');
            });
          }
        });
      }
    }
  }

  public participation_checkForErrors(): number {
    let errorCount = 0;
    const errors = {};
    for (const row of this.participation.rows) {
			errors[row.index] = {count: 0, action: false, reason: false};
      if (row.is === 'role') {
				console.log('check', {role: row.role, action: row.action, reason: row.reason, userId: row.userId});
        if (row.action == null) {
          errorCount++;
          errors[row.index]['action'] = true;
          errors[row.index]['count']++;
        } else if (row.action === false && (row.reason === null || row.reason === 'null')) {
          errorCount++;
          errors[row.index]['reason'] = true;
          errors[row.index]['count']++;
        }
      }
    }
    this.participation.errors = errors;
		console.log('participation_checkForErrors', errors);
    return errorCount;
  }


  public participation_load() {
    this.participation.loading = true;
    this.participation.isSuperApprover = this.user.hasGroup('SUPER_APPROVERS');
    this.participation.isApprover = this.user.hasGroup('APPROVERS');

    this.api.reports_retrieveParticipation(this.participation.id, () => {
      document.location.href = '/p/reports';
    }).then(participationEntity => {

      this.participation.title = 'Report ' + participationEntity.Report.Name + ' ' + participationEntity.Report.Year + ' for ';
      if (participationEntity.SORUserOverridenApproverId) {
        this.participation.title += participationEntity.SORUserOverridenApprover?.FirstName + ' ' + participationEntity.SORUserOverridenApprover?.LastName;
      } else {
        this.participation.title += participationEntity.SORUserApprover?.FirstName + ' ' + participationEntity.SORUserApprover?.LastName;
      }

			const approverLogin = participationEntity.SORUserOverridenApprover ? participationEntity.SORUserOverridenApprover?.Login : participationEntity.SORUserApprover?.Login;
			console.log('participation', approverLogin, this.user.getLogin());

      this.participation.readonly =
				(
					!this.participation.isSuperApprover
					&& participationEntity.StatusId !== 'pending'
				)
				||
				(
					(
						this.participation.isSuperApprover
						&& participationEntity.StatusId !== 'completed'
					)
				);

			// special : if approver and super approver then you can open the report assigned to you

			if (this.participation.isSuperApprover && this.participation.isApprover && participationEntity.StatusId === 'pending' &&
				approverLogin === this.user.getLogin()
			) {
        this.participation.reportAllowedAsApproverWhileBeingSuperApprover = true;
        this.participation.readonly = false;
      }
			console.log({
				isSuperApprover: this.participation.isSuperApprover,
				isApprover: this.participation.isApprover,
				status: participationEntity.StatusId,
				approverLogin,
				login: this.user.getLogin(),
				readonly: this.participation.readonly
			});

      this.participation.entity = participationEntity;
      this.api.reports_retrieveRowsForParticipationId(this.participation.id).then(rows => {
        let lastUser = null;
        let lastSystem = null;
        let i = 0;
				console.log('adding rows', rows.length);
        for (const row of rows) {
					const user = row.SystemBatchRow.SORUser?.FirstName ?
						(row.SystemBatchRow.SORUser?.FirstName + ' ' + row.SystemBatchRow.SORUser?.LastName) :
						row.SystemBatchRow.SORUser.Login;
          const userId = row.SystemBatchRow.SORUser.Id;
          if (!row.SystemBatchRow.SystemRole) {
						console.error('error ROW without role,see SystemBatchRow:', row.SystemBatchRow);
          }
					const system = row.SystemBatchRow.SystemRole.System.Name;
					const systemId = row.SystemBatchRow.SystemRole.System.Id;

					if (!this.participation.rowsByUserId[userId]) {
						this.participation.rowsByUserId[userId] = [];
					}
					if (!this.participation.rowsByUserAndSystemId[userId]) {
						this.participation.rowsByUserAndSystemId[userId] = {};
					}
					if (!this.participation.rowsByUserAndSystemId[userId][systemId]) {
						this.participation.rowsByUserAndSystemId[userId][systemId] = [];
					}

          if (user !== lastUser) {
            this.participation.rows.push({
							is: 'user',
							id: null,
							user,
							userId,
							systemId,
							system: '',
							role: '',
							roleDescription: '',
							action: null,
							reason: null,
							status: '',
							index: i,
              userNameInSystem: row.SystemBatchRow.UserName,
              userIsPrivileged: row.SystemBatchRow.IsUserPrivileged || row.SystemBatchRow.SORUser.IsPrivilegedAccount,
            });
            i++;
          }
          if (user !== lastUser || system !== lastSystem) {
            const rowSystem = {
							is: 'system',
							id: null,
							user: '',
							userId,
							system,
							systemId,
							roleDescription: '',
							role: '',
							action: null,
							reason: null,
							status: '',
							userNameInSystem: row.SystemBatchRow.UserName,
							index: i
            };
            i++;
            this.participation.rows.push(rowSystem);
            this.participation.rowsByUserId[userId].push(rowSystem);
            this.participation.rowsByUserAndSystemId[userId][systemId].push(rowSystem);
          }

          let action = row.StatusId == null || row.StatusId === 'pending' ? null : row.StatusId === 'approved';
          let reason = row.RejectionReason;

          const originalAction = action;
          const originalReason = reason;

          let override = false;
					// console.log('?', row);
          if (row.OverridenStatusId !== null && row.OverridenStatusId !== row.StatusId) {
            override = true;
            action = row.OverridenStatusId === 'approved';
          }
          if (row.OverridenRejectionReason !== null && row.OverridenStatusId === 'rejected' && row.OverridenRejectionReason !== row.RejectionReason) {
            override = true;
            reason = row.OverridenRejectionReason;
          }

					// console.log('add', row.Id, action, reason);

          let firstPairing = false;
					if (row.SystemBatchRow.SystemRole.Pairing) {
            if (!this.participation.rolePairing[row.SystemBatchRow.SystemRole.Pairing.Id + '-' + userId]) {
              this.participation.rolePairing[row.SystemBatchRow.SystemRole.Pairing.Id + '-' + userId] = [];
              this.participation.rolePairingDisplay[row.SystemBatchRow.SystemRole.Pairing.Id + '-' + userId] = false;
              firstPairing = true;
            } else {
              firstPairing = false;
            }
          }


          const newrow = {
						is: 'role',
						id: row.Id,
						user: '',
						userId,
						system: '',
						systemId,
						roleDescription: row.SystemBatchRow.SystemRole.Description,
						role: row.SystemBatchRow.MappedRoleName,
            pairingId: row.SystemBatchRow.SystemRole?.Pairing ? row.SystemBatchRow.SystemRole.Pairing.Id + '-' + userId : '',
						pairing: row.SystemBatchRow.SystemRole?.Pairing,
            firstPairing,
						roleId: row.SystemBatchRow.SystemRole.Id,
						action,
						reason,
						originalAction,
						originalReason,
						isOverride: override,
						status: '',
						index: i,
            userNameInSystem: row.SystemBatchRow.UserName,
            // ── AD Group from systems_loaders.json AccessGroups via DB query ──
            // e.g. "HCC Inf Developers" for role "Infinity Developers"
            adGroups: row.AdGroup ? [row.AdGroup] : [],
            // ──────────────────────────────────────────────────────────────────
          };


          this.participation.rows.push(newrow);
          this.participation.rowsByUserId[userId].push(newrow);
          this.participation.rowsByUserAndSystemId[userId][systemId].push(newrow);

					if (row.SystemBatchRow.SystemRole.Pairing) {
            if (!firstPairing) {
              this.participation.rolePairing[row.SystemBatchRow.SystemRole.Pairing.Id + '-' + userId].push(this.participation.rows.length - 1);
            }
          }


          lastUser = user;
          lastSystem = system;

          i++;
        }


        this.participation.loading = false;
      });
    });
  }


	public lastTime = {
		loading: false,
		noResults: false,
		data: [],
		title: ''
	};

  public lastTime_statusFor(d) {
    const status = d.OverridenStatusId != null ? d.OverridenStatusId : d.StatusId;

    switch (status) {
			case 'pending':
				return null;
			case 'approved':
				return true;
			case 'rejected':
				return false;
    }
  }

  public lastTime_load(sorUserId, d) {
    this.modal.show();
    this.lastTime.loading = true;
    this.lastTime.data = [];
    this.lastTime.noResults = false;
    this.lastTime.title = 'Last Time';
    this.api.reports_rowBySORUserId(this.participation.entity.Report.Id, sorUserId).then(r => {
			// filter to have only the available ones
			// this.participation.rows
      const systemRolesIdsToKeep = [];
      for (const row of this.participation.rows) {
				console.log('=', row['userId'], sorUserId);
				if (row['userId'] == sorUserId) {
					systemRolesIdsToKeep.push(row['roleId']);
				}
      }
      for (const row2 of r) {
				console.log('check row', row2['SystemBatchRow']['SystemRoleId'], systemRolesIdsToKeep.indexOf(row2['SystemBatchRow']['SystemRoleId']));

        if (systemRolesIdsToKeep.indexOf(row2['SystemBatchRow']['SystemRoleId']) !== -1) {
          this.lastTime.data.push(row2);
          this.lastTime.title = 'Last Time - Report ' + row2['ReportParticipation'].Report.Name + ' ' + row2['ReportParticipation'].Report.Year + ' - for user ' + d.user;
        }
      }
			if (this.lastTime.data.length === 0) {
				this.lastTime.noResults = true;
			}
      this.lastTime.loading = false;
    }, e => {
      this.lastTime.loading = false;
			console.error('promise.e', e);
			if (e.status === 409) {
				this.lastTime.noResults = true;
			} else {
				this.alert('Sorry, please try again');
			}
    });


  }

  public lastTime_carryForward() {

    for (const current of this.participation.rows) {
      for (const lastTime of this.lastTime.data) {
				/*
				DecisionBy: "(login:Administrator)"
				DecisionDate: "2020-11-25T14:48:02.2224049"
				Id: 108
				OverridenDecisionBy: "(login:jeanroger)"
				OverridenDecisionDate: "2020-11-25T14:52:00.4674894"
				OverridenRejectionReason: "access_not_required"
				OverridenStatusId: "rejected"
				RejectionReason: "user_unknown"
				ReportParticipation: {Id: 2, CreatedDate: "2020-11-25T14:39:42.777", StatusId: "counter_signed", Notes: "test", CompletedBy: "(login:Administrator)", …}
				ReportParticipationId: 2
				StatusId: "rejected"
				SystemBatchRow: {Id: 108, IsEnriched: true, NeedsAnomalyCheck: false, NeedsSODCheck: true, AnomalyCount: 0, …}
				SystemBatchRowId: 108
				 */
        if (current['userId'] === lastTime.SystemBatchRow.SORUserId && current['roleId'] === lastTime.SystemBatchRow.SystemRoleId) {
					console.log('lastTime_carryForward', current['userId'], current['roleId'], lastTime);
          let action = lastTime.StatusId == null || lastTime.StatusId === 'pending' ? null : lastTime.StatusId === 'approved';
          let reason = lastTime.RejectionReason;

          if (lastTime.OverridenStatusId !== null) {
            action = lastTime.OverridenStatusId === 'approved';
            reason = null;
            if (lastTime.OverridenRejectionReason !== null && (lastTime.OverridenStatusId === 'rejected')) {
              reason = lastTime.OverridenRejectionReason;
            }
          }
					// console.log('fwd', lastTime, reason);

          current['action'] = action;
          current['reason'] = reason;
          current['originalreason'] = reason;

          this.row_saveChanges(current);
        }
      }
    }
    this.modal.hide();
  }
}
